import React from "react";
import { parseBody } from "./markdownLite.js";
import { isSharePointUrl } from "./publicView.js";

// Renders the item body format as React elements only (no dangerouslySetInnerHTML), so text a
// user types can never become markup. Links open outside the current window. A SharePoint/OneDrive
// link is never rendered as a link (defense in depth behind publicView) — only its text shows.
function Spans({ spans }) {
  return spans.map((s, i) => {
    if (s.t === "b") return <strong key={i}>{s.v}</strong>;
    if (s.t === "a" && isSharePointUrl(s.href)) return <React.Fragment key={i}>{s.v}</React.Fragment>;
    if (s.t === "a") return <a key={i} href={s.href} target="_blank" rel="noopener noreferrer">{s.v}</a>;
    return <React.Fragment key={i}>{s.v}</React.Fragment>;
  });
}

export default function MarkdownLite({ text, style }) {
  const blocks = parseBody(text);
  if (!blocks.length) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, ...style }}>
      {blocks.map((b, i) => b.type === "ul" ? (
        <ul key={i} style={{ margin: 0, paddingLeft: 22, display: "flex", flexDirection: "column", gap: 6 }}>
          {b.items.map((spans, j) => <li key={j}><Spans spans={spans} /></li>)}
        </ul>
      ) : (
        <p key={i} style={{ margin: 0 }}>
          {b.lines.map((spans, j) => <React.Fragment key={j}>{j > 0 && <br />}<Spans spans={spans} /></React.Fragment>)}
        </p>
      ))}
    </div>
  );
}
